import styled from 'styled-components';
import { colors, Typography, Icon } from 'syngenta-digital-cropwise-react-ui-kit';
import breakpoints from 'base/constants/breakpoints';

export const Title = styled(Typography.Title)`
  font-style: normal;
  font-weight: 400;
  font-size: 24px;
  line-height: 32px;
  letter-spacing: -0.0125em;
  color: ${colors.neutral100};

  @media screen and ${breakpoints.maxWidth.sm} {
    font-family: Noto Sans;
    font-size: 16px;
    font-weight: 550;
    line-height: 24px;
    letter-spacing: -0.0075em;
    padding: 8px 16px;
  }
`;

export const Text = styled(Typography.Text)`
  color: var(--Text-Info-Text-Info-Hover-Tertiary, #232630);
  font-family: 'Noto Sans';
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px; /* 150% */
  letter-spacing: -0.12px;

  @media screen and ${breakpoints.maxWidth.sm} {
    display: block;
    margin: 0 16px;
    color: var(--Neutral-neutral-70, #4d5165);

    /* Regular / 14px | 20px */
    font-family: 'Noto Sans';
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 20px; /* 142.857% */
    letter-spacing: -0.105px;
  }
`;

export const Container = styled.div`
  border: 1px solid ${colors.neutral20};
  border-radius: 8px;
  padding: 16px;
  margin-top: 16px;
  margin-bottom: 16px;

  @media screen and ${breakpoints.maxWidth.sm} {
    padding: 12px;
    margin-top: 12px;
    margin-bottom: 12px;
  }
`;

export const SeedTechnologyContainer = styled.div`
  margin-top: 16px;

  @media screen and ${breakpoints.maxWidth.sm} {
    margin-top: 12px;
  }
`;

export const SeedTechnologyTitle = styled.div`
  color: #14151c;
  font-family: 'Noto Sans';
  font-size: 20px;
  font-style: normal;
  font-weight: 400;
  line-height: 28px;
  letter-spacing: -0.15px;
  margin-bottom: 12px;
`;

export const TechnologyOptionsContainer = styled.div`
  display: flex;
  gap: 12px;
  margin-bottom: 20px;
  max-width: 100%;
  flex-wrap: wrap;
  justify-content: flex-start;

  @media screen and ${breakpoints.maxWidth.sm} {
    flex-direction: row;
    flex-wrap: wrap;
    gap: 8px;
    margin-bottom: 16px;
    max-width: 100%;
    justify-content: flex-start;
  }
`;

export const TechnologyOption = styled.div`
  border-radius: 4px;
  padding: 12px 16px;
  min-width: 150px;
  text-align: left;
  border: 1px solid #0071cd;
  background: #eaf6ff;
  color: #2f3031;
  font-family: 'Noto Sans';
  font-size: 24px;
  font-style: normal;
  font-weight: 600;
  line-height: 32px; /* 133.333% */
  letter-spacing: -0.3px;
  word-break: break-word;
  overflow-wrap: break-word;
  flex: 1 0 auto;
  box-sizing: border-box;

  @media (max-width: 1024px) {
    min-width: 140px;
    font-size: 22px;
    line-height: 30px;
    padding: 10px 14px;
  }

  @media screen and ${breakpoints.maxWidth.sm} {
    width: calc(50% - 4px);
    min-width: calc(50% - 4px);
    max-width: calc(50% - 4px);
    flex: none;
    box-sizing: border-box;
    padding: 8px 12px;
    font-size: 18px;
    line-height: 24px;
    text-align: center;
  }
`;

export const SectionHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 8px 0;
  border-bottom: 1px solid ${colors.neutral20};
  margin-top: 20px;
  margin-bottom: 16px;
`;

export const SectionTitle = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  color: #14151c;
  font-family: 'Noto Sans';
  font-size: 20px;
  font-style: normal;
  font-weight: 400;
  line-height: 28px;
  letter-spacing: -0.15px;
`;

export const ProductsGrid = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  margin-bottom: 20px;

  @media screen and ${breakpoints.maxWidth.sm} {
    gap: 8px;
    margin-bottom: 16px;
    justify-content: flex-start;
  }
`;

export const ProductCard = styled.div`
  border: 1px solid #dfe2e7;
  border-radius: 4px;
  padding: 7px;
  min-width: 180px;
  flex: 1;
  max-width: 260px;
`;

export const ProductCardTotal = styled.div`
  border: 1px solid #dfe2e7;
  border-radius: 4px;
  padding: 12px;
  min-width: 180px;
  flex: 1;
  max-width: 260px;
  height: 80px;
  border: 1px solid var(--Border-Active-Border-Active-Enabled-Primary, #0071cd);
  background: var(--Surface-Info-Surface-Info-Primary, #eaf6ff);

  @media screen and ${breakpoints.maxWidth.sm} {
    display: flex;
    width: calc(50% - 4px);
    max-width: calc(50% - 4px);
    min-width: calc(50% - 4px);
    flex: none;
    flex-direction: column;
    align-items: flex-start;
    gap: 8px;
    flex-shrink: 0;
    height: auto;
    min-height: 70px;
    box-sizing: border-box;
  }
`;

export const ProductInfo = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 4px;
  color: #2f3031;
  font-family: 'Noto Sans';
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: 24px; /* 150% */
  letter-spacing: -0.12px;
`;

export const ProductInfoLine = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
`;

export const ProductLeftSection = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const ProductRightSection = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
`;

export const WeedLink = styled.a`
  color: ${colors.blue60};
  text-decoration: underline;
  cursor: pointer;
`;

export const IconWrapper = styled.div`
  cursor: pointer;
`;

export const TechnologyFitContainer = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 8px;
  margin-top: 8px;
`;

export const TechnologyFitBar = styled.div`
  height: 20px;
  width: 4px;
  border-radius: 0px 4px 4px 0px;
  background: #2fb966;
  margin-right: 8px;
`;

export const ApplicationFitBar = styled.div`
  height: 20px;
  width: 4px;
  border-radius: 0px 4px 4px 0px;
  background: #c2c7d0;
  flex-shrink: 0; /* Prevent shrinking */
  align-self: center; /* Ensure vertical alignment */
`;

export const TechnologyFitText = styled.span`
  font-size: 14px;
`;

export const InfoIcon = styled(Icon)`
  margin-left: 4px;
  color: ${colors.neutral60};
`;

export const ResistanceContainer = styled.div`
  margin-bottom: 16px;
`;

export const ResistanceTitle = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 8px;
`;

export const ResistanceText = styled.span`
  margin-left: 8px;
  color: var(--Text-Default-Text-Default-Primary, #14151c);
  font-family: 'Noto Sans';
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px;
  letter-spacing: -0.12px;
`;

export const ResistanceList = styled.ul`
  margin: 0;
  padding-left: 45px;
`;

export const ResistanceItem = styled.li`
  margin-bottom: 4px;
  color: #696f88;
  font-family: 'Noto Sans';
  font-size: 16px;
  font-style: italic;
  font-weight: 400;
  line-height: 24px; /* 150% */
  letter-spacing: -0.12px;
`;

export const ApplicationContainer = styled.div`
  margin-bottom: 16px;
`;

export const ApplicationHeader = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 12px;
`;

export const ApplicationTitle = styled.div`
  color: #4d5165;
  font-family: 'Noto Sans';
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px; /* 150% */
  letter-spacing: -0.12px;
  margin-right: 8px;

  @media screen and ${breakpoints.maxWidth.sm} {
    color: var(--Neutral-neutral-70, #4d5165);

    /* Regular / 14px | 20px */
    font-family: 'Noto Sans';
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 20px; /* 142.857% */
    letter-spacing: -0.105px;
  }
`;

export const ApplicationType = styled.div`
  color: #14803c;
  font-family: 'Noto Sans';
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px; /* 150% */
  letter-spacing: -0.12px;
  @media screen and ${breakpoints.maxWidth.sm} {
    color: var(--Text-Default-Text-Default-Enabled-Secondary, #14803c);

    /* Regular / 14px | 20px */
    font-family: 'Noto Sans';
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 20px; /* 142.857% */
    letter-spacing: -0.105px;
  }
`;

export const ApplicationProductsGrid = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
`;

export const WeedControlContainer = styled.div`
  margin-top: 24px;
`;

export const WeedControlTitle = styled.div`
  color: #14151c;
  font-family: 'Noto Sans';
  font-size: 20px;
  font-style: normal;
  font-weight: 400;
  line-height: 28px; /* 140% */
  letter-spacing: -0.15px;
  margin-bottom: 16px;

  @media screen and ${breakpoints.maxWidth.sm} {
    color: var(--Text-Default-Text-Default-Primary, #14151c);
    font-family: 'Noto Sans';
    font-size: 14px;
    font-style: normal;
    font-weight: 600;
    line-height: 22px; /* 157.143% */
    letter-spacing: -0.105px;
  }
`;

export const WeedControlGrid = styled.div`
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
  justify-content: flex-start;
  overflow-x: visible;

  @media screen and ${breakpoints.maxWidth.sm} {
    flex-wrap: wrap;
    gap: 6px;
    overflow-x: visible;
    justify-content: flex-start;
  }
`;

export const WeedCard = styled.div`
  border: 1px solid ${colors.neutral30};
  border-radius: 4px;
  padding: 12px;
  min-width: 120px;
  text-align: center;
  display: flex;
  flex-direction: column;
  flex: 1 0 200px;
  box-sizing: border-box;
  max-width: 300px;

  @media (max-width: 1024px) {
    flex: 1 0 180px;
    min-width: 180px;
    padding: 10px;
  }

  @media screen and ${breakpoints.maxWidth.sm} {
    width: calc(50% - 3px);
    min-width: calc(50% - 3px);
    max-width: calc(50% - 3px);
    flex: none;
    box-sizing: border-box;
    padding: 8px;
  }
`;

export const WeedName = styled.div`
  margin-bottom: 8px;
  text-align: left;
  color: #14151c;
  font-family: 'Noto Sans';
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: 24px; /* 150% */
  letter-spacing: -0.12px;
  word-break: break-word; /* Break long names */
  flex: 0 0 auto; /* Don't allow this to grow */
  width: 100%; /* Ensure it takes full width */
  overflow-wrap: break-word; /* Ensure words break to fit container */

  @media (max-width: 1024px) {
    font-size: 15px;
    line-height: 22px;
  }

  @media screen and ${breakpoints.maxWidth.sm} {
    color: var(--Text-Default-Text-Default-Primary, #14151c);
    font-family: 'Noto Sans';
    font-size: 14px;
    font-style: normal;
    font-weight: 600;
    line-height: 20px; /* 142.857% */
    letter-spacing: -0.105px;
  }
`;

export const ControlRate = styled.div`
  font-size: 14px;
  color: ${colors.neutral70};
  margin-bottom: 4px;
`;

export const ControlInfo = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
  align-items: center;
  font-size: 14px;
  color: ${colors.neutral70};
  flex: 1; /* Allow it to take remaining space */
  margin-top: auto; /* Push to bottom when there's excess space */
  gap: 4px;

  span {
    color: var(--Text-Default-Text-Default-Secondary, #696f88);
    font-family: 'Noto Sans';
    font-size: 12px;
    font-style: normal;
    font-weight: 400;
    line-height: 20px;
    letter-spacing: -0.09px;
  }
`;

export const ControlPercentage = styled.div<{ color?: string }>`
  margin-left: 4px;
  font-family: 'Noto Sans';
  font-size: 12px;
  font-style: normal;
  font-weight: 600;
  line-height: 16px;
  letter-spacing: -0.09px;
  color: ${({ color }) => color || 'inherit'};
  min-width: 40px;
  text-align: center;
  box-sizing: border-box;
  flex-shrink: 0;

  @media (max-width: 1024px) {
    margin-left: 2px;
    min-width: 36px;
  }

  @media screen and ${breakpoints.maxWidth.sm} {
    min-width: 33px;
    max-width: 60px;
    text-align: center;
    margin-left: 0;
  }
`;

export const SprayIconWrapper = styled.div`
  padding: 2px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const ProductName = styled.span`
  color: var(--Text-Default-Text-Default-Primary, #14151c);
  font-family: 'Noto Sans';
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px;
  letter-spacing: -0.12px;
  vertical-align: middle;
`;

export const ProductRate = styled.span`
  color: var(--Text-Default-Text-Default-Primary, #14151c);
  font-family: 'Noto Sans';
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px; /* 150% */
  letter-spacing: -0.12px;
  vertical-align: middle;
`;

export const ProductUnit = styled.span`
  color: var(--Text-Default-Text-Default-Secondary, #696f88);
  font-family: 'Times New Roman';
  font-size: 16px;
  font-style: italic;
  font-weight: 400;
  line-height: 24px;
`;
